/**
 * One empty state (docs/design-system.md, "Placeholder page"). It answers a non-admin who types
 * an admin hash (views/AdminRoute.tsx): the server gives that person a 404 (docs/specs/
 * accounts.md, section 9), and the page says the same thing.
 */
export function PlaceholderView({ label, text }: { label: string; text: string }): JSX.Element {
  return (
    <div className="placeholder-view">
      <div className="panel grat placeholder-panel">
        <span className="label">{label}</span>
        <p className="muted">{text}</p>
      </div>
    </div>
  );
}
